import React, { useImperativeHandle, useState, forwardRef, useRef } from 'react'
function CombineInput({error, status, setInputVal, onValidate},refPassed) {
    
    const [inp1, setInp1] = useState();
    const [inp2, setInp2] = useState();
    const [inp3, setInp3] = useState();
    const inp1Ref = useRef()
    const inp2Ref = useRef()
    const inp3Ref = useRef()
    useImperativeHandle(refPassed, ()=>({
        getValue:()=>{
            console.log([inp1,inp2,inp3]);
            return [inp1,inp2,inp3].join("-");
        },
        reset:()=>{
            inp1Ref.current.value = ""
            inp2Ref.current.value = ""
            inp3Ref.current.value = ""
            setInp1(inp1Ref.current.value)
            setInp2(inp2Ref.current.value)
            setInp3(inp3Ref.current.value)
        }
    }))    
    const onKeyUp = (e)=> {
        if(e.which === 9 || e.which === 16 || e.which === 17 || e.which === 18 || e.which === 37 ||  e.which === 39){
            return;
        };
        
        
        const target = e.srcElement || e.target;
        const maxLength = parseInt(target.attributes["maxlength"].value, 10);
        const  myLength = target.value.length;
        if (myLength >= maxLength) {
            let next = target.nextElementSibling;
            while (next.nextElementSibling !== null) {
                if (next.tagName.toLowerCase() === "input") {
                    next.focus();
                    break;
                }
                next = next.nextElementSibling;
            }
        }
        else if (myLength === 0) {
            let previous = target.previousElementSibling;
            while (previous !== null) {
                if (previous.tagName.toLowerCase() === "input") {
                    previous.focus();
                    break;
                }
                previous = previous.previousElementSibling;
            }
        }
        let inputVal = [inp1,inp2,inp3].join("-");
        setInputVal(inputVal);
        if(e.which == 13 && error==="" && status ===""){
            onValidate(e);
        }
    }

    const onPaste =(evt)=>{
        let paste = (evt.clipboardData || window.clipboardData).getData('text');
        const regex = /(...)[-\s](...)[-\s](...)/i
        if(regex.exec(paste) !== null){
            const vals = regex.exec(paste);
            inp1Ref.current.value = vals[1]
            inp2Ref.current.value = vals[2]
            inp3Ref.current.value = vals[3]
        } else {
            inp1Ref.current.value = paste.substr(0,3)
            inp2Ref.current.value = paste.substr(3,3)
            inp3Ref.current.value = paste.substr(6,3)
        }
        setInp1(inp1Ref.current.value)
        setInp2(inp2Ref.current.value)
        setInp3(inp3Ref.current.value)
    }
	return(
		<div className={"digital-text-fields " + (error !== "" ? "error": "")} onKeyUp={onKeyUp} onPaste={onPaste}> 
			<input type="text" maxLength="3" ref={inp1Ref} onChange={evt=>{setInp1(evt.target.value)}} />
			<input type="text" maxLength="3" ref={inp2Ref} onChange={evt=>(setInp2(evt.target.value))}/>
			<input type="text" maxLength="3" ref={inp3Ref} onChange={evt=>(setInp3(evt.target.value))}/>
       		<span className="icon-download-digital icon-download-digital-success hide"></span>
       </div>
	)
}


export default forwardRef(CombineInput)